module.exports = __webpack_public_path__ + "img/vrconk.ad52e828.jpg";